module.exports = __webpack_public_path__ + "img/appendMark.4bb51645.svg";